// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_Kg5","cls2":"ClaimDetails-cls2_AFI ClaimDetails-cls1_Kg5"};